import { render, staticRenderFns } from "./PartnerLocatorNearest.vue?vue&type=template&id=79c18f4c"
import script from "./PartnerLocatorNearest.vue?vue&type=script&lang=js"
export * from "./PartnerLocatorNearest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PartnerTypeBadges: require('/app/components/PartnerTypeBadges.vue').default})
